import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import Divider from '@material-ui/core/Divider';
import GridItem from 'components/Grid/GridItem.js';
import Snackbar from "components/Snackbar/Snackbar.js";
import GridContainer from 'components/Grid/GridContainer.js';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardHeader from 'components/Card/CardHeader.js';
import CardBody from 'components/Card/CardBody.js';
import CardFooter from 'components/Card/CardFooter.js';
import Circular from 'components/Circular/Circular';
import { api } from '../../services/api';
import { updateLocker, getConfigLocker, updateConfigLocker } from '../../services/lockers/lockers';
import { getAllUsers } from '../../services/users/users';
import AddAlert from "@material-ui/icons/AddAlert";
import Action from 'components/Action/Action';
import { Checkbox, FormControlLabel, FormGroup } from '@material-ui/core';
import LockerStruct from 'components/LockerStruct';
import LockerNotitication from 'components/LockerNotification/LockerNotitication';
import File from 'components/Files/File';
import JSONInput from 'react-json-editor-ajrm';
import locale from 'react-json-editor-ajrm/locale/pt';

const LockerConfig = (props) => {
  const [lockers, setLockers] = useState([]);
  const [configs, setConfiguration] = useState();
  const [circular, setCircular] = useState(true);
  const [servicosDispon, setServicosDispon] = useState('');
  const [metodo, setMetodo] = useState('');
  const [status, setStatus] = useState('');
  const [grupo, setGrupo] = useState('');
  const [segunda, setSegunda] = useState('');
  const [segundaFim, setSegundaFim] = useState('');
  const [terca, setTerca] = useState('');
  const [tercaFim, setTercaFim] = useState('');
  const [quarta, setQuarta] = useState('');
  const [quartaFim, setQuartaFim] = useState('');
  const [quinta, setQuinta] = useState('');
  const [quintaFim, setQuintaFim] = useState('');
  const [sexta, setSexta] = useState('');
  const [sextaFim, setSextaFim] = useState('');
  const [sabado, setSabado] = useState('');
  const [sabadoFim, setSabadoFim] = useState('');
  const [domingo, setDomingo] = useState('');
  const [domingoFim, setDomingoFim] = useState('');
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [success, setSuccess] = useState('');
  const [message, setMessage] = useState('');
  const [role, setRole] = useState(null);
  const [expiration, setExpirationHours] = useState(72);
  const [complemento, setComplemento] = useState('');
  const [condominio, setCondominio] = useState('TODO');
  const [configJson, setConfigJson] = useState({});

  const [ala, setAla] = useState('');
  const [bloco, setBloco] = useState('');
  const [apto_numero, setNumeroApto] = useState('');
  const [nomeApto, setNomeApto] = useState('');

  const [mode, setMode] = useState('');

  const [whatsapp, setWhatsapp] = useState(false);

  const [inventario, setInventario] = useState(false);

  const [showCommand, setShowCommand] = useState(false);
  const [showConfig, setShowConfig] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [showFiles, setShowFiles] = useState(false);

  const { classes, lockerId, lockerName } = props;

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    getAllUsers((users) => {
      let currentUser = users.filter(u => u.email === user.data.email)[0];
      if (currentUser && currentUser.roleName)
        setRole(currentUser.roleName);
    });
  }, []);

  useEffect(() => {
    const urlTest = `/lockers/${lockerId}`;

    api.get(urlTest).then((res) => {
      // console.log("FABRIKA: ", JSON.stringify(res.data.data));
      setLockers(res.data.data);
    }
    );
  }, [lockerId]);

  useEffect(() => {
    const urlConfig = `/locker/${lockerId}/config`;

    api.get(urlConfig).then((res) => {
      // console.log("RES DATA", JSON.stringify(res.data))
      setConfiguration(res.data)
    });
  }, [lockerId]);

  useEffect(() => {

    getConfigLocker(lockerId, (response) => {
      // console.log('RESPONSE:', response)
      if (response) {
        setConfigJson(response);
      }

    });
  }, [lockerId]);

  useEffect(() => {
    setStatus(lockers.status);
  }, [lockers]);

  const handleChange = (event) => {
    const e = event.target.id ? event.target.id : event.target.name;
    const { value } = event.target;

    switch (e) {
      case 'servicos-dispon':
        setServicosDispon(value);
        break;
      case 'metodo':
        setMetodo(value);
        break;
      case 'status':
        setStatus(value);
        break;
      case 'mode':
        setMode(value);
        break;
      case 'grupo':
        setGrupo(String(value));
        break;
      case 'segunda-inicio':
        setSegunda(value);
        break;
      case 'segunda-fim':
        setSegundaFim(value);
        break;
      case 'terca-inicio':
        setTerca(value);
        break;
      case 'terca-fim':
        setTercaFim(value);
        break;
      case 'quarta-inicio':
        setQuarta(value);
        break;
      case 'quarta-fim':
        setQuartaFim(value);
        break;
      case 'quinta-inicio':
        setQuinta(value);
        break;
      case 'quinta-fim':
        setQuintaFim(value);
        break;
      case 'sexta-inicio':
        setSexta(value);
        break;
      case 'sexta-fim':
        setSextaFim(value);
        break;
      case 'sabado-inicio':
        setSabado(value);
        break;
      case 'sabado-fim':
        setSabadoFim(value);
        break;
      case 'domingo-inicio':
        setDomingo(value);
        break;
      case 'domingo-fim':
        setDomingoFim(value);
        break;
      case 'expiration':
        setExpirationHours(value);
        break;
      case 'complemento':
        setComplemento(value);
        break;
      case 'ala':
        setAla(!ala)
        break;
      case 'bloco':
        setBloco(!bloco)
        break;
      case 'apto_numero':
        setNumeroApto(!apto_numero)
        break;
      case 'nomeApto':
        setNomeApto(!nomeApto)
        break;
      case 'whatsapp':
        setWhatsapp(!whatsapp)
        break;
      case 'inventario':
        setInventario(!inventario)
        break;

    }
  };

  const handleUpdate = (e) => {
    let data = {
      status: status,
      group_lockers: grupo,
      allocation_method: metodo,
      available_services: servicosDispon,
      expiration_hours: expiration,
      ala: ala,
      bloco: bloco,
      numero_apto: apto_numero,
      nome_apto: nomeApto,
      whatsapp: whatsapp,
      hasInventory: inventario,
      mode: mode,
      working_hours: {
        monday: {
          init: segunda,
          final: segundaFim
        },
        tuesday: {
          init: terca,
          final: tercaFim
        },
        weensday: {
          init: quarta,
          final: quartaFim
        },
        thursday: {
          init: quinta,
          final: quintaFim
        },
        friday: {
          init: sexta,
          final: sextaFim
        },
        saturday: {
          init: sabado,
          final: sabadoFim
        },
        sunday: {
          init: domingo,
          final: domingoFim
        },
      }
    };

    updateLocker(lockerId, data, (response) => {
      if (response.length > 0) {
        setSuccess('success');
        setMessage('Locker atualizado com sucesso!');
        setOpenSnackbar(true);
      } else {
        setSuccess('danger');
        setMessage('Locker não foi atualizado!');
        setOpenSnackbar(true);
      }
    });
  };



  const handleUpdateConfig = (e) => {
    let data = {
      config: configJson,
    };

    updateConfigLocker(lockerId, configJson, (response) => {
      console.log(JSON.stringify(response));
      // if (response.length > 0) {
      //   setSuccess('success');
      //   setMessage('Locker atualizado com sucesso!');
      //   setOpenSnackbar(true);
      // } else {
      //   setSuccess('danger');
      //   setMessage('Locker não foi atualizado!');
      //   setOpenSnackbar(true);
      // }
    });
  };

  const handleClose = () => {
    setOpenSnackbar(false);
  }

  if (lockers != '' && circular) {
    setStatus(lockers.status);
    setGrupo(lockers.group_lockers);
    setMetodo(lockers.allocation_method);
    setServicosDispon(lockers.available_services);
    setExpirationHours(lockers.expiration_hours);
    setAla(lockers.ala);
    setBloco(lockers.bloco);
    setMode(lockers.mode);
    setNumeroApto(lockers.apto_numero);
    setNomeApto(lockers.nomeApto);
    setWhatsapp(lockers.whatsapp);
    setInventario(lockers.hasInventory);

    if (lockers.working_hours) {
      let working_hours = lockers.working_hours;
      setSegunda(working_hours.monday.init);
      setSegundaFim(working_hours.monday.final);

      setTerca(working_hours.tuesday.init);
      setTercaFim(working_hours.tuesday.final);

      setQuarta(working_hours.weensday.init);
      setQuartaFim(working_hours.weensday.final);

      setQuinta(working_hours.thursday.init);
      setQuintaFim(working_hours.thursday.final);

      setSexta(working_hours.friday.init);
      setSextaFim(working_hours.friday.final);

      setSabado(working_hours.saturday.init);
      setSabadoFim(working_hours.saturday.final);

      setDomingo(working_hours.sunday.init);
      setDomingoFim(working_hours.sunday.final);
    }
  }

  const HighlightedJSON = ({ jsonParse }) => {

    try {
      const json = JSON.parse(configJson);

      const highlightedJSON = jsonObj =>
        Object.keys(jsonObj).map(key => {
          const value = jsonObj[key];
          let valueType = typeof value;
          const isSimpleValue =
            ["string", "number", "boolean"].includes(valueType) || !value;
          if (isSimpleValue && valueType === "object") {
            valueType = "null";
          }
          return (
            <div key={key} className="line">
              <span className="key">"{key}":</span>
              {isSimpleValue ? (
                <span className={valueType}>{`${(valueType == "string") ? '"' + value + '"' : value}`};</span>
              ) : (
                highlightedJSON(value)
              )}
            </div>
          );
        });
      return <div
        className="json"
        contentEditable={true}
        onInput={e => {
          console.log('Text inside div', e.currentTarget.textContent);
          setConfigJson(e.currentTarget.textContent);
        }}>{highlightedJSON(json)}</div>;

    } catch {

      return <div
        className="json"
        contentEditable={true}
        onInput={e => {
          console.log('Text inside div', e.currentTarget.textContent);
          setConfigJson(e.currentTarget.textContent);
        }}>{configJson}</div>;

    }

  };

  const handleCommand = () => {
    setShowCommand(!showCommand);
    setShowConfig(false);
    setShowNotification(false);
    setShowFiles(false);
  }

  const handleConfig = () => {
    setShowConfig(!showConfig);
    setShowCommand(false);
    setShowNotification(false);
    setShowFiles(false);
  }

  const handleNotification = () => {
    setShowNotification(!showNotification);
    setShowCommand(false);
    setShowConfig(false);
    setShowFiles(false);
  }

  const handleFiles = () => {
    setShowFiles(!showFiles);
    setShowNotification(false);
    setShowCommand(false);
    setShowConfig(false);
  }

  if (status != '' && grupo != '' && circular) {
    setCircular(false);
  }

  return circular ? (
    <Circular />
  ) : (
    <div>
      <GridContainer>
        <GridItem >
          <div className="up-buttons-configs">
            <Button color="primary" onClick={handleCommand} >Enviar Comando</Button>
            {(configs?.id) && <Button color="primary" onClick={handleNotification} >Notificações</Button>}
            <Button color="primary" onClick={handleFiles} >Arquivos</Button>
            <Button color="primary" onClick={handleConfig} >Configurações do Locker</Button>
          </div>

          <Action show={showCommand} lockerName={lockerName} lockerId={lockerId} />

          {(configs?.id) && <LockerNotitication show={showNotification} config={configs} lockerId={lockerId} lockerName={lockerName} />}

          <File show={showFiles} lockerId={lockerId} lockerName={lockerName} />

          {!showConfig ? (<></>) : (
            <>
              <Card>
                <CardHeader color="primary">
                  <h4>Configurações do Locker</h4>
                  <p>
                    <strong>ID:</strong> {lockers?.id}<br />
                    <strong>Nome:</strong> {lockers?.name}<br />
                    <strong>ID Público:</strong> {lockers?.publicLockerId}<br />
                    <strong>Status:</strong> {lockers?.status}<br />
                    <strong>Versão App:</strong> {lockers?.app_version}<br />
                    {(lockers?.qi_version) && <><strong>Versão QI:</strong> {lockers?.qi_version}<br /></>}
                    {(lockers?.ui_version) && <><strong>Versão UI:</strong> {lockers?.ui_version}<br /></>}
                    <strong>Bateria:</strong> {lockers?.bateria}<br />
                    <strong>Tipo:</strong> {lockers?.lockerType ? ((lockers?.lockerType == 0) ? 'cci' : lockers?.lockerType) : ((lockers?.ui_version) ? 'cci' : 'ecommerce')}<br />
                    <strong>Geolocalização:</strong> <a target="_blank" style={{ color: '#FFFFFF' }} href={`https://www.google.com/maps/search/?api=1&query=${lockers?.geolocation?.latitude},${lockers?.geolocation?.longitude}`}>Latitude: {lockers?.geolocation?.latitude} - Longitude: {lockers?.geolocation?.longitude}</a><br />
                    <strong>Endereço:</strong> {lockers?.address?.Endereço} - {lockers?.address?.Bairro} - {lockers?.address?.UF} - {lockers?.address?.CEP}<br />
                  </p>
                </CardHeader>
                <CardBody>
                  <GridContainer>
                    <br></br>
                    <Divider />
                    <br></br>
                    <GridItem xs={12} sm={12} md={12}>
                      <Typography variant="subtitle1">Status do Terminal</Typography>
                    </GridItem>

                    <GridItem xs={12} sm={12} md={12}>
                      <TextField
                        id="mode"
                        name="mode"
                        select
                        disabled={role !== 'Administrador'}
                        value={mode === '' ? 'active' : mode}
                        onChange={(e) => handleChange(e)}
                      >
                        <MenuItem value="active" key="1d">
                          Em operação
                        </MenuItem>
                        <MenuItem value="installing" key="2d">
                          Em ativação
                        </MenuItem>
                        <MenuItem value="maintenance" key="3d">
                          Em manutenção
                        </MenuItem>
                        <MenuItem value="inactive" key="4d">
                          Inativo
                        </MenuItem>
                      </TextField>
                    </GridItem>

                  </GridContainer>
                </CardBody>
              </Card>



              <Card>
                <CardBody>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <Typography variant="subtitle1">Horario de funcionamento</Typography>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <Typography variant="subtitle1">Segunda-feira</Typography>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3}>
                      <TextField
                        id="segunda-inicio"
                        label="Hora de Inicio"
                        type="time"
                        disabled={role !== 'Administrador'}
                        value={segunda}
                        onChange={(e) => handleChange(e)}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      ></TextField>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3}>
                      <TextField
                        id="segunda-fim"
                        label="Hora de Fim"
                        type="time"
                        disabled={role !== 'Administrador'}
                        value={segundaFim}
                        onChange={(e) => handleChange(e)}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      ></TextField>
                    </GridItem>
                    <Divider />
                    <GridItem xs={12} sm={12} md={6}>
                      <Typography variant="subtitle1">Terça-feira</Typography>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3}>
                      <TextField
                        id="terca-inicio"
                        label="Hora de Inicio"
                        type="time"
                        disabled={role !== 'Administrador'}
                        value={terca}
                        onChange={(e) => handleChange(e)}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      ></TextField>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3}>
                      <TextField
                        id="terca-fim"
                        label="Hora de Fim"
                        type="time"
                        disabled={role !== 'Administrador'}
                        value={tercaFim}
                        onChange={(e) => handleChange(e)}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      ></TextField>
                    </GridItem>
                    <Divider />
                    <GridItem xs={12} sm={12} md={6}>
                      <Typography variant="subtitle1">quarta-feira</Typography>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3}>
                      <TextField
                        id="quarta-inicio"
                        label="Hora de Inicio"
                        type="time"
                        disabled={role !== 'Administrador'}
                        value={quarta}
                        onChange={(e) => handleChange(e)}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      ></TextField>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3}>
                      <TextField
                        id="quarta-fim"
                        label="Hora de Fim"
                        type="time"
                        disabled={role !== 'Administrador'}
                        value={quartaFim}
                        onChange={(e) => handleChange(e)}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      ></TextField>
                    </GridItem>
                    <Divider />
                    <GridItem xs={12} sm={12} md={6}>
                      <Typography variant="subtitle1">quinta-feira</Typography>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3}>
                      <TextField
                        id="quinta-inicio"
                        label="Hora de Inicio"
                        type="time"
                        disabled={role !== 'Administrador'}
                        value={quinta}
                        onChange={(e) => handleChange(e)}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      ></TextField>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3}>
                      <TextField
                        id="quinta-fim"
                        label="Hora de Fim"
                        type="time"
                        disabled={role !== 'Administrador'}
                        value={quintaFim}
                        onChange={(e) => handleChange(e)}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      ></TextField>
                    </GridItem>
                    <Divider />
                    <GridItem xs={12} sm={12} md={6}>
                      <Typography variant="subtitle1">sexta-feira</Typography>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3}>
                      <TextField
                        id="sexta-inicio"
                        label="Hora de Inicio"
                        type="time"
                        disabled={role !== 'Administrador'}
                        value={sexta}
                        onChange={(e) => handleChange(e)}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      ></TextField>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3}>
                      <TextField
                        id="sexta-fim"
                        label="Hora de Fim"
                        type="time"
                        disabled={role !== 'Administrador'}
                        value={sextaFim}
                        onChange={(e) => handleChange(e)}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      ></TextField>
                    </GridItem>
                    <Divider />
                    <GridItem xs={12} sm={12} md={6}>
                      <Typography variant="subtitle1">Sabado</Typography>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3}>
                      <TextField
                        id="sabado-inicio"
                        label="Hora de Inicio"
                        type="time"
                        disabled={role !== 'Administrador'}
                        value={sabado}
                        onChange={(e) => handleChange(e)}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      ></TextField>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3}>
                      <TextField
                        id="sabado-fim"
                        label="Hora de Fim"
                        type="time"
                        disabled={role !== 'Administrador'}
                        value={sabadoFim}
                        onChange={(e) => handleChange(e)}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      ></TextField>
                    </GridItem>
                    <Divider />
                    <GridItem xs={12} sm={12} md={6}>
                      <Typography variant="subtitle1">Domingo</Typography>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3}>
                      <TextField
                        id="domingo-inicio"
                        label="Hora de Inicio"
                        type="time"
                        disabled={role !== 'Administrador'}
                        value={domingo}
                        onChange={(e) => handleChange(e)}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      ></TextField>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3}>
                      <TextField
                        id="domingo-fim"
                        label="Hora de Fim"
                        type="time"
                        disabled={role !== 'Administrador'}
                        value={domingoFim}
                        onChange={(e) => handleChange(e)}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      ></TextField>
                    </GridItem>
                  </GridContainer>
                </CardBody>
              </Card>


              <Card>
                <CardBody>

                  <GridContainer>
                    <GridItem xs={12} sm={12} md={6}>
                      <Typography variant="subtitle1">Metodo de alocação</Typography>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <TextField
                        id="metodo"
                        name="metodo"
                        select
                        disabled={role !== 'Administrador'}
                        value={metodo}
                        onChange={(e) => handleChange(e)}
                      >
                        <MenuItem value="Dinâmico" key="dinamico">
                          Dinâmico
                        </MenuItem>
                        <MenuItem value="Manual" key="manual">
                          Manual
                        </MenuItem>
                      </TextField>
                    </GridItem>
                  </GridContainer>
                  <br></br>
                  <Divider />
                  <br></br>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={6}>
                      <Typography variant="subtitle1">Prazo de expiração de encomendas (horas)</Typography>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <TextField
                        id="expiration"
                        name="expiration"
                        type={"number"}
                        disabled={role !== 'Administrador'}
                        value={expiration}
                        onChange={(e) => handleChange(e)}
                      >
                      </TextField>
                    </GridItem>
                  </GridContainer>
                  <br></br>
                  <Divider />
                  <br></br>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={6}>
                      <Typography variant="subtitle1">Condomínio</Typography>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <TextField
                        id="condominio"
                        name="condominio"
                        disabled={true}
                        value={condominio}
                      >
                      </TextField>
                    </GridItem>
                    <br></br>
                    <GridItem xs={12} sm={12} md={6}>
                      <Typography variant="subtitle1">Complemento</Typography>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <TextField
                        id="complemento"
                        name="complemento"
                        disabled={role !== 'Administrador'}
                        value={complemento}
                        onChange={(e) => handleChange(e)}
                      >
                      </TextField>
                    </GridItem>
                  </GridContainer>
                </CardBody>
              </Card>


              <Card>
                <CardBody>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <Typography variant="subtitle1">Tipo de Operação</Typography>
                      <FormGroup row>
                        <FormControlLabel
                          control={<Checkbox checked={ala} onChange={(e) => handleChange(e)} name="ala" />}
                          label="Ala"
                        />
                        <FormControlLabel
                          control={<Checkbox checked={bloco} onChange={(e) => handleChange(e)} name="bloco" />}
                          label="Bloco"
                        />

                        <FormControlLabel
                          control={<Checkbox checked={apto_numero} onChange={(e) => handleChange(e)} name="apto_numero" />}
                          label="Número Apto"
                        />
                        <FormControlLabel
                          control={<Checkbox checked={nomeApto} onChange={(e) => handleChange(e)} name="nomeApto" />}
                          label="Nome"
                        />
                      </FormGroup>
                    </GridItem>
                  </GridContainer>
                  <br></br>
                  <Divider />
                  <br></br>
                  <GridContainer>
                    <GridItem>
                      <Typography variant="subtitle1">Envio de Notificações</Typography>
                      <FormControlLabel
                        control={<Checkbox checked={whatsapp} onChange={(e) => handleChange(e)} name="whatsapp" />}
                        label="WhatsApp"
                      />
                    </GridItem>
                  </GridContainer>
                  <Divider />
                  <br></br>
                  <GridContainer>
                    <GridItem>
                      <Typography variant="subtitle1">Gestão de Inventário</Typography>
                      <FormControlLabel
                        control={<Checkbox checked={inventario} onChange={(e) => handleChange(e)} name="inventario" />}
                        label="Gestão de Inventário"
                      />
                    </GridItem>
                  </GridContainer>
                </CardBody>
              </Card>


              <Card>
                <CardBody>
                  <CardFooter>
                    <Button color="primary" disabled={role !== 'Administrador'} onClick={(e) => handleUpdate(e)}>Atualizar paramêtros</Button>
                  </CardFooter>
                </CardBody>
              </Card>


              {(role == 'Administrador') && <Card>
                <CardBody>
                  <GridContainer>
                    <GridItem>
                      <Typography variant="subtitle1">Configurações JSON</Typography>
                      {/* <HighlightedJSON
                          // json={configJson}
                        onChange={(e) => handleChange(e)} name="whatsapp" /> */}
                      <JSONInput
                        placeholder={configJson} // data to display
                        theme="dark_vscode_tribute"
                        onChange={(e) => {
                          console.log('Text inside div', e.json);
                          if (e.jsObject != undefined) {
                            console.log("JSON Válido:", e.jsObject)
                            setConfigJson(e.jsObject);
                          }
                        }}
                        locale={locale}
                        colors={{
                          // string: "#DAA520" // overrides theme colors with whatever color value you want
                        }}
                        height="550px"
                      />
                    </GridItem>
                  </GridContainer>
                  <CardFooter>
                    <Button color="primary" disabled={role !== 'Administrador'} onClick={(e) => handleUpdateConfig(e)}>Atualizar Config</Button>
                  </CardFooter>
                </CardBody>
              </Card>}

            </>
          )}
        </GridItem>
      </GridContainer>
      <Snackbar
        place="tc"
        color={success}
        icon={AddAlert}
        message={message}
        open={openSnackbar}
        closeNotification={() => handleClose()}
        close
      />
    </div>
  );
};

export default LockerConfig;
